import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcDmvCrashReportsDetails from './NcDmvCrashReportsDetails';

const NcDmvCrashReportsModal = ({ selectedCrashReport, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Driver&apos;s License Number: {selectedCrashReport.externalAccountId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcDmvCrashReportsDetails selectedCrashReport={selectedCrashReport} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcDmvCrashReportsModal;

NcDmvCrashReportsModal.propTypes = {
  selectedCrashReport: PropTypes.instanceOf(Object).isRequired,
};
